import { createApp } from 'vue';
import PdfViewer from '../components/PdfViewer.vue';

function initPdfViewer() {
  const viewerWrappers = document.querySelectorAll('.wp-block-group.pdf-viewer-wrapper');

  viewerWrappers.forEach((viewerWrapper) => {
    const objectEl = viewerWrapper.querySelector('object.wp-block-file__embed');
    if (!objectEl) return;

    const pdfSrc = objectEl.getAttribute('data');
    if (!pdfSrc) return;

    const downloadWrapper = viewerWrapper.nextElementSibling;
    let downloadText = 'Download PDF';

    if (downloadWrapper && downloadWrapper.classList.contains('pdf-download-wrapper')) {
      const downloadLink = downloadWrapper.querySelector('a.wp-block-button__link');
      if (downloadLink) {
        downloadText = downloadLink.textContent.trim();
      }
      downloadWrapper.remove();
    }

    const mountPoint = document.createElement('div');
    mountPoint.className = 'vue-pdf-viewer-mount';
    viewerWrapper.replaceWith(mountPoint);

    createApp(PdfViewer, { pdfSrc, downloadText }).mount(mountPoint);

    console.log(`[PdfViewer] Initialized with src: ${pdfSrc}`);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPdfViewer);
} else {
  initPdfViewer();
}